<label class="sr-only" [for]="inputId()">{{ displayLabel() }}</label>
<button
    class="search-trigger icon-only"
    data-qpx-search-trigger
    qpxButton
    [matButton]="appearance()"
    matBadge="•"
    matBadgeColor="accent"
    matBadgeSize="small"
    [matBadgeHidden]="!hasCollapsedValue()"
    [size]="size()"
    [attr.aria-label]="triggerLabel()"
    [attr.aria-controls]="inputId()"
    [attr.aria-expanded]="isExpanded()"
    [attr.tabindex]="isExpanded() ? -1 : 0"
    [disabled]="disabled()"
    (click)="expandSearch()"
>
    <ng-icon qpx name="lucideSearch" [size]="size()" matButtonIcon />
</button>
<mat-form-field
    [class]="allFieldClasses()"
    data-qpx-search-field
    qpxInput="search-filter"
    [size]="size()"
    [attr.aria-hidden]="!isExpanded()"
    subscriptSizing="dynamic"
>
    <ng-icon matPrefix qpx name="lucideSearch" [size]="size()" />
    <input
        type="text"
        #searchInput
        [id]="inputId()"
        spellcheck="false"
        autocomplete="off"
        [placeholder]="placeholderText()"
        matInput
        maxlength="50"
        [(ngModel)]="value"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disabled()"
        [attr.tabindex]="isExpanded() ? 0 : -1"
        (focus)="expandSearch()"
    />

    @let emptySearch = !value().length;
    <button
        qpxButton
        matSuffix
        matIconButton
        [size]="size()"
        aria-label="Clear"
        [disabled]="disabled() || emptySearch"
        [class.invisible]="emptySearch"
        [attr.tabindex]="isExpanded() ? 0 : -1"
        (click)="clearSearch()"
    >
        <ng-icon qpx name="lucideX" [size]="size()" />
    </button>
</mat-form-field>
